import { getDependentColor } from './DependentBadge';

interface DependentMultiSelectProps {
  dependents: Array<{ id: string; name: string }>;
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}

export function DependentMultiSelect({ dependents, selectedIds, onChange }: DependentMultiSelectProps) {
  if (dependents.length <= 1) return null;

  const toggle = (id: string) => {
    if (selectedIds.includes(id)) {
      // Don't allow deselecting the last one
      if (selectedIds.length > 1) {
        onChange(selectedIds.filter((s) => s !== id));
      }
    } else {
      onChange([...selectedIds, id]);
    }
  };

  return (
    <div className="mb-4">
      <p className="text-sm font-medium text-gray-700 mb-2">For:</p>
      <div className="flex flex-wrap gap-2">
        {dependents.map((dep, index) => {
          const selected = selectedIds.includes(dep.id);
          const color = getDependentColor(index);
          return (
            <button
              key={dep.id}
              type="button"
              onClick={() => toggle(dep.id)}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${
                selected
                  ? `${color.bg} ${color.text} ${color.border}`
                  : 'bg-white text-gray-500 border-gray-300 hover:border-gray-400'
              }`}
            >
              <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${selected ? color.dot : 'bg-gray-300'}`} />
              {dep.name}
              {selected && <span className="ml-0.5 text-xs">✓</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
